import { Timestamp, timestampDate } from '@bufbuild/protobuf/wkt'
import { addDays, subDays } from 'date-fns'

import {
  formatDateToJSTYYYYMMddTimeStamp,
  formatYYYYMMdd,
} from '@enechain/eposition-utils'

/**
 * @ref endDate は exclusive で扱うため、翌日の 00:00:00 を指定する
 * @link https://ene-chain.slack.com/archives/C0659A97E48/p1749696744979939?thread_ts=1749695108.450369&cid=C0659A97E48
 */
export function getDeliveryEndDateTimestamp(
  value: Date | undefined,
): Timestamp | undefined {
  if (value === undefined) {
    return undefined
  }

  return formatDateToJSTYYYYMMddTimeStamp(addDays(value, 1))
}

/**
 * @ref endDate は exclusive で扱うため、表示時には 1 日引く
 * @link https://ene-chain.slack.com/archives/C0659A97E48/p1749696744979939?thread_ts=1749695108.450369&cid=C0659A97E48
 */
export function getDeliveryEndDateString(
  value: Timestamp | undefined,
): string | undefined {
  if (value === undefined) {
    return undefined
  }

  return formatYYYYMMdd(subDays(timestampDate(value), 1), '/')
}
